import { createFileRoute } from "@tanstack/react-router";
import { MissionEditor } from "@/features/mission-editor/mission-editor";

export const Route = createFileRoute("/misionbankeditor")({
  component: MissionEditor,
});
